/* eslint-disable */

const state = {
    document: {},
    exists: false
}

const mutations = {
    'SET_DOCUMENT' (state, data) {
        state.exists = true;
        state.document.Document_ID = data.Document_ID;
        state.document.Document_Name = data.Document_Name;
        state.document.Title = data.Title;
        state.document.PDF_Filename = data.PDF_Filename;
        state.document.Background_Color = data.Background_Color;
    },
    'SET_NAME' (state, name) {
        state.document.Document_Name = name;
    },
    'DOC_CREATED' (state) {
        state.exists = true;
    },
    'PDF_FILENAME' (state, name) {
        state.document.PDF_Filename = name;
    }
}

const actions = {
    setDocument: ({commit}, doc) => {
        commit('SET_DOCUMENT', doc);
    },
    setName: ({commit}, name) => {
        commit('SET_NAME', name);
    },
    created: ({commit}) => {
        commit('DOC_CREATED');
    },
    setPDF: ({commit}, name) => {
        commit('PDF_FILENAME', name);
    }
}

const getters = {
    document: state => {
        return state.document;
    },
    docExists: state => {
        return state.exists;
    }
}

export default {
    state,
    mutations,
    actions,
    getters
}


// WEBPACK FOOTER //
// ./src/store/modules/document.js